import { css } from 'styled-components'
import ofc from '../../settings/variables'
const styles = css`
    background-color:#fff;
    border-bottom:1px solid ${ofc.bgLight};

`

export default styles
    